import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
} from "./types";

import AuthService from "../services/auth.service";


export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      console.log(data)
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      // dispatch({
      //   type: LOGIN_FAIL,
      // });

      return Promise.reject();
    }
  );
};

export const checkToken = (sessions) => async (dispatch) => {
  try {
    const res = await AuthService.checkToken(sessions);
    if(res){
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: res },
      });

      return res.data
    }
  } catch (error) {
      console.log("error: ", error)
      return error;
  }
}

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};
